import { useEffect, useState } from "react";
import PhoneStep from "./PhoneStep";
import OtpStep from "./OtpStep";
import StepperHeader from "./StepperHeader";

const ChangePhoneSheet = ({ open, onClose }) => {

    const [step, setStep] = useState(1);

    const [phone, setPhone] = useState("");

    const [otp, setOtp] = useState("");
    
    useEffect(() => {
        if(open)
            document.querySelector('body').style.overflowY = 'hidden'

        return () => {
            document.querySelector('body').style.overflowY = 'auto'
        }

    }, [open]);

    const handleSuccessClose = () => {
        // ریست کامل stateهای sheet
        setStep(1);
        setPhone("");
        setOtp("");

        // بستن sheet
        onClose();
    };

    if (!open) return null;

    return (

        <div className="fixed inset-0 z-50 flex items-end">

            <div onClick={onClose} className=" bg-black/40 absolute left-0 top-0 w-full h-full"></div>

            <div className="w-full z-10 bg-white rounded-t-3xl shadow-2xl animate-slideUp max-w-lg mx-auto">

                <div className="w-12 h-1.5 bg-slate-300 rounded-full mx-auto mt-3"></div>

                 <StepperHeader step={step} setStep={setStep} />

                {step === 1 && (
                    <PhoneStep
                        phone={phone}
                        setPhone={setPhone}
                        onNext={() => setStep(2)}
                    />
                )}

                {step === 2 && (
                    <OtpStep
                        phone={phone}
                        otp={otp}
                        setOtp={setOtp}
                        onBack={() => setStep(1)}
                        onSuccessClose={handleSuccessClose}
                    />
                )}

                <div className="md:pb-6 pb-[78px] text-center">
                    <button
                        onClick={onClose}
                        className="text-sm text-slate-400"
                    >
                        بستن
                    </button>
                </div>

            </div>

        </div>
    );
};

export default ChangePhoneSheet;